import React, { useState, useEffect } from 'react';
import "../../styles/ChargeCode.css";
import AsyncSelect from 'react-select/async';
import { ToastContainer, toast } from "react-toastify";
import Select from 'react-select';
import { components } from 'react-select';
import axiosInstance from '../../axiosInstance';

const ChargeCodePopup = ({ closePopup, onSubmit, editData }) => {
    const [charge_code, setChargeCode] = useState('');
    const [charge_name, setChargeName] = useState('');
    const [sapInput, setSapInput] = useState(null);
    const [sapDescription, setSapDescription] = useState('');
    const [glInput, setGlInput] = useState(null);
    const [glDescription, setGlDescription] = useState('');
    const [chargeType, setChargeType] = useState('');
    const [category_id, setType] = useState('');
    const [typeOptions, setTypeOptions] = useState([]);
    const [uom, setUom] = useState('');
    const [uomOptions, setUomOption] = useState([]);
    const [sapOptions, setSapOptions] = useState([]);

    const [errors, setErrors] = useState({
        charge_code: '',
        charge_name: '',
        sapCode: '',
        sapDesc: '',
        category_id: '',
        glCode: '',
        glDesc: '',
        chargeType: ''
    });

    console.log('typeOptions', typeOptions);
    console.log('uomOptions', uomOptions);


    // Initialize form with edit data if available
    //  ('https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/charge/getcharges')

    useEffect(() => {
        const fetchCategory = async () => {
            try {
                const response = await axiosInstance.get(
                    `/costsolution/category/autosuggestion`
                );
                console.log("res", response);

                console.log(response.data.autosuggestion)
                if (response.data && Array.isArray(response.data.autosuggestion)) {
                    console.log("categories");
                    console.log("categories......", response.data.autosuggestion);
                    setType(response.data.autosuggestion);
                    setTypeOptions(response.data.autosuggestion);
                    const categories = response?.data?.autosuggestion || [];
                    if (editData && editData.categoryId) {
                        const matchedCategory = categories.find(cat => cat.value === editData.categoryId);
                        if (matchedCategory) {
                            setType(matchedCategory.value);
                        }
                    }
                }
            }
            catch (error) {
                console.error("Failed to fetch job options:", error);
            };
        }
        fetchCategory();
    }, []);

    useEffect(() => {
        const fetchUom = async () => {
            try {
                const response = await axiosInstance.get(`/costsolution/uom/autosuggestion`);
                if (response.data && Array.isArray(response.data.autosuggestion)) {
                    setUomOption(response.data.autosuggestion);

                    // Preselect UOM if editData exists
                    if (editData?.uomID) {
                        const matchedUom = response.data.autosuggestion.find(
                            (u) => u.value === editData.uomID
                        );
                        if (matchedUom) {
                            setUom(matchedUom.value);
                        }
                    }
                }
            } catch (error) {
                console.error("Failed to fetch uom options:", error);
            }
        };
        fetchUom();
    }, [editData]);


    useEffect(() => {
        if (editData) {
            setChargeCode(editData.charge_code || '');
            setChargeName(editData.charge_name || '');
            setType(editData.categoryId || '');
            setUom(editData.uomID || editData.uomcode || '');
            setUomOption([{ value: editData.uomID, label: editData.uomcode }]);
            if (editData.charge_type) {
                setChargeType(editData.charge_type);
            }
            // Preload SAP code as AsyncSelect option
            if (editData.sap_id && editData.sap_code && editData.sap_description) {
                const option = {
                    value: editData.sap_id,
                    label: editData.sap_code,
                    description: editData.sap_description
                };
                setSapInput(option);
                setSapDescription(editData.sap_description);
            }
            if (editData.gl_code && editData.gl_description) {
                const option = {
                    value: editData.gl_id || null,
                    label: editData.gl_code,
                    description: editData.gl_description
                };
                setGlInput(option);
                setGlDescription(editData.gl_description);
            }

        }
    }, [editData]);

    const loadSapOptions = async (inputValue, callback) => {
        try {
            const res = await axiosInstance.get('/charge/getSapDetails', {
                params: { term: inputValue }
            });

            const options = res.data.sap_details
                .slice(0, 6)
                .map(opt => ({
                    label: opt.label,
                    value: opt.value,
                    description: opt.label1
                }));

            setSapOptions(options);
            callback(options);
        } catch (err) {
            console.error("SAP fetch error", err);
            callback([]);
        }
    };

    const loadGlOptions = async (inputValue, callback) => {
        try {
            const res = await axiosInstance.get('/charge/getGLDetails', {
                params: { term: inputValue }
            });

            const options = (res.data.autosuggestion || [])
                .slice(0, 5)
                .map(opt => ({
                    label: opt.label,
                    value: opt.value,
                    description: opt.label1
                }));

            callback(options);
        } catch (err) {
            console.error("GL fetch error", err);
            callback([]);
        }
    };




    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({
            charge_code: '',
            charge_name: '',
            sapid: '',
            category_id: ''
        });

        let hasError = false;
        const newErrors = {
            charge_code: '',
            charge_name: '',
            sapCode: '',
            sapDesc: '',
            category_id: '',
            glCode: '',
            glDesc: '',
            chargeType: ''
        };

        if (!chargeType) {
            newErrors.chargeType = 'Please select Charge Type';
            hasError = true;
        }

        if (!charge_code.trim()) {
            newErrors.charge_code = 'Please enter the charge code';
            hasError = true;
        }
        if (!charge_name.trim()) {
            newErrors.charge_name = 'Please enter the charge name';
            hasError = true;
        }

        if (chargeType === 'sales') {
            if (!sapInput || !sapInput.label) {
                newErrors.sapCode = 'Please enter the SAP code';
                hasError = true;
            }

            if (!sapDescription.trim()) {
                newErrors.sapDesc = 'Please enter the SAP description';
                hasError = true;
            }
        }

        // if (!category_id || isNaN(category_id)) {
        //     newErrors.category_id = 'Please select a category';
        //     hasError = true;
        // }

        if (chargeType === 'cost') {
            if (!glInput?.label) {
                newErrors.glCode = 'Please enter the GL code';
                hasError = true;
            }

            if (!glDescription.trim()) {
                newErrors.glDesc = 'Please enter the GL description';
                hasError = true;
            }
        }

        if (hasError) {
            setErrors(newErrors);
            return;
        }


        let sap_id = sapInput?.value;
        if (chargeType === 'Sales' && !sap_id) {
            try {
                const res = await axiosInstance.post('/charge/create_sapDetails', {
                    sap_code: sapInput.label,
                    sap_description: sapDescription
                });
                if (res.data.success) {
                    sap_id = res.data.data.value;
                    toast.success("New SAP created successfully");
                }
            } catch (err) {
                toast.error("Failed to create SAP");
                return;
            }
        }

        let gl_id = glInput?.value;
        if (chargeType === 'cost' && !gl_id) {
            try {
                const res = await axiosInstance.post('/charge/create_glDetails', {
                    gl_code: glInput.label,
                    gl_description: glDescription
                });
                if (res.data.success) {
                    gl_id = res.data.data.value;
                    toast.success("New GL created successfully");
                }
            } catch (err) {
                toast.error("Failed to create GL");
                return;
            }
        }


        const formData = {
            charge_type: chargeType,
            charge_code,
            charge_name,
            sap_id,
            gl_id,
            category_id: Number(category_id),
            uom_id: uom !== '' ? Number(uom) : null
        };

        onSubmit(formData);
    };

    const handleClear = () => {
        setChargeCode('');
        setChargeName('');
        setSapInput(null);
        setSapDescription('');
        setType('');
        setUom('');
        setErrors({
            charge_code: '',
            charge_name: '',
            sapid: '',
            category_id: ''
        });
    };

    const isFieldRequired = (field) => {
        if (chargeType === 'sales') {
            return field === 'sap' || field === 'sapdesc';
        } else if (chargeType === 'cost') {
            return field === 'gl' || field === 'gldesc';
        }
        return false;
    };

    const ClearIndicator = (props) => {
        return (
            <components.ClearIndicator
                {...props}
                innerProps={{
                    ...props.innerProps,
                    onMouseDown: (e) => {
                        e.stopPropagation();
                        props.clearValue();
                    }
                }}
            />
        );
    };


    return (
        <>
            <div className="charge-code-popup-overlay">
                <div className="charge-code-popup-container">

                    <div className="charge-code-creation-popup-header">
                        <h2>{editData ? 'Edit Charge Code' : 'Create New Charge Code'}</h2>
                        <button className="close-button" onClick={closePopup}>×</button>
                    </div>

                    <form onSubmit={handleSubmit}>

                        <div className="charge-code-creation-popup-body">

                            <div className="charge-code-popup-form-group">
                                <label htmlFor="chargeType" className="charge-code-popup-label">
                                    Charge Type <span style={{ color: 'red' }}>*</span>
                                </label>
                                <select
                                    id="chargeType"
                                    className="charge-code-popup-input"
                                    value={chargeType}
                                    onChange={(e) => setChargeType(e.target.value)}
                                >
                                    <option value="">Select Charge Type</option>
                                    <option value="sales">Sales</option>
                                    <option value="cost">Cost</option>
                                </select>
                                {errors.chargeType && (
                                    <div className="error-message" style={{ color: 'red', fontSize: '12px' }}>
                                        {errors.chargeType}
                                    </div>
                                )}
                            </div>


                            <div className="charge-code-form-row-grid">
                                <div className="charge-code-popup-form-group">
                                    <label htmlFor="code" className="charge-code-popup-label">Code <span style={{ color: 'red' }}>*</span></label>
                                    <input
                                        type="text"
                                        id="charge_code"
                                        className="charge-code-popup-input"
                                        placeholder='Enter charge code...'
                                        value={charge_code}
                                        onChange={(e) => setChargeCode(e.target.value)}
                                        style={{ margin: '0px' }}
                                    />
                                    {errors.charge_code && (
                                        <div className="error-message" style={{ color: 'red', fontSize: '12px' }}>
                                            {errors.charge_code}
                                        </div>
                                    )}
                                </div>

                                <div className="charge-code-popup-form-group">
                                    <label htmlFor="name" className="charge-code-popup-label">Name  <span style={{ color: 'red' }}>*</span></label>
                                    <input
                                        type="text"
                                        id="charge_name"
                                        className="charge-code-popup-input"
                                        value={charge_name}
                                        placeholder='Enter charge name...'
                                        onChange={(e) => setChargeName(e.target.value)}
                                        style={{ margin: '0px' }}
                                    />
                                    {errors.charge_name && (
                                        <div className="error-message" style={{ color: 'red', fontSize: '12px' }}>
                                            {errors.charge_name}
                                        </div>)}
                                </div>
                            </div>

                            <div className="charge-code-form-row-grid">
                                <div className="charge-code-popup-form-group">
                                    <label className="charge-code-popup-label">SAP Code {isFieldRequired('sap') && <span style={{ color: 'red' }}>*</span>}</label>
                                    <AsyncSelect
                                        cacheOptions
                                        defaultOptions
                                        loadOptions={loadSapOptions}
                                        value={sapInput}
                                        onChange={(selected) => {
                                            setSapInput(selected);
                                            setSapDescription(selected?.description || '');
                                        }}
                                        onInputChange={(inputValue, { action }) => {
                                            if (action === 'input-change') {
                                                setSapInput({ label: inputValue, value: null });
                                                setSapDescription('');
                                            }
                                        }}
                                        isClearable
                                        components={{ ClearIndicator }}
                                        placeholder="Enter or select SAP code"
                                        noOptionsMessage={({ inputValue }) =>
                                            inputValue ? `Create new SAP code "${inputValue}"` : "No SAP codes found"
                                        }
                                        styles={{
                                            container: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                            }),
                                            control: (provided) => ({
                                                ...provided,
                                                minHeight: '32px',
                                                fontSize: '13px',
                                                color: '#525A66',
                                                borderRadius: '4px',
                                                borderColor: '#d1d5db',
                                                boxShadow: 'none',
                                            }),
                                            placeholder: (provided) => ({
                                                ...provided,
                                                fontSize: '13px',
                                                color: '#999',
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 9999,
                                            }),
                                        }}
                                    />

                                    {errors.sapCode && <div className="error-message" style={{ color: 'red', fontSize: '12px' }}>{errors.sapCode}</div>}
                                </div>

                                <div className="charge-code-popup-form-group">
                                    <label className="charge-code-popup-label">SAP Description {isFieldRequired('sapdesc') && <span style={{ color: 'red' }}>*</span>}</label>
                                    <input
                                        type="text"
                                        style={{ margin: '0px', backgroundColor: sapInput?.value ? '#f5f5f5' : 'white' }}
                                        className="charge-code-popup-input"
                                        placeholder="Enter SAP description..."
                                        value={sapDescription}
                                        onChange={(e) => setSapDescription(e.target.value)}
                                        readOnly={!!sapInput?.value}
                                    />
                                    {errors.sapDesc && <div className="error-message" style={{ color: 'red', fontSize: '12px' }}>{errors.sapDesc}</div>}
                                </div>
                            </div>

                            <div className="charge-code-form-row-grid">
                                <div className="charge-code-popup-form-group">
                                    <label className="charge-code-popup-label">
                                        GL Code {isFieldRequired('gl') && <span style={{ color: 'red' }}>*</span>}
                                    </label>
                                    <AsyncSelect
                                        cacheOptions
                                        defaultOptions
                                        loadOptions={loadGlOptions}
                                        value={glInput}
                                        onChange={(selected) => {
                                            setGlInput(selected);
                                            setGlDescription(selected?.description || '');
                                        }}
                                        onInputChange={(inputValue, { action }) => {
                                            if (action === 'input-change') {
                                                setGlInput({ label: inputValue, value: null });
                                                setGlDescription('');
                                            }
                                        }}
                                        isClearable
                                        components={{ ClearIndicator }}
                                        placeholder="Enter or select GL code"
                                        noOptionsMessage={({ inputValue }) =>
                                            inputValue ? `Create new GL code "${inputValue}"` : "No GL codes found"
                                        }
                                        styles={{
                                            container: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                            }),
                                            control: (provided) => ({
                                                ...provided,
                                                minHeight: '32px',
                                                fontSize: '13px',
                                                color: '#525A66',
                                                borderRadius: '4px',
                                                borderColor: '#d1d5db', // optional: match input border color
                                                boxShadow: 'none',
                                            }),
                                            placeholder: (provided) => ({
                                                ...provided,
                                                fontSize: '13px',
                                                color: '#999',
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 9999,
                                            }),
                                            option: (base, { isFocused }) => ({
                                                ...base,
                                                backgroundColor: isFocused ? '#f2f2f2' : '#fff',
                                                color: '#333',
                                                padding: '10px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #eee',
                                                '&:active': {
                                                    backgroundColor: '#f2f2f2'
                                                }
                                            }),
                                        }}
                                    />
                                    {errors.glCode && (
                                        <div className="error-message" style={{ color: 'red', fontSize: '12px' }}>
                                            {errors.glCode}
                                        </div>
                                    )}
                                </div>

                                <div className="charge-code-popup-form-group">
                                    <label className="charge-code-popup-label">
                                        GL Description {isFieldRequired('gldesc') && <span style={{ color: 'red' }}>*</span>}
                                    </label>
                                    <input
                                        type="text"
                                        style={{
                                            margin: '0px',
                                            backgroundColor: glInput?.value ? '#f5f5f5' : 'white'
                                        }}
                                        className="charge-code-popup-input"
                                        placeholder="Enter GL description..."
                                        value={glDescription}
                                        onChange={(e) => setGlDescription(e.target.value)}
                                        readOnly={!!glInput?.value}
                                    />
                                    {errors.glDesc && (
                                        <div className="error-message" style={{ color: 'red', fontSize: '12px' }}>
                                            {errors.glDesc}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="charge-code-form-row-grid">
                                <div className="charge-code-popup-form-group" style={{ flex: 1 }}>
                                    <label htmlFor="type" className="charge-code-popup-label">
                                        Category
                                    </label>
                                    <Select
                                        id="type"
                                        value={typeOptions.find(opt => opt.value === category_id) || null}
                                        onChange={(selectedOption) => setType(selectedOption ? selectedOption.value : '')}
                                        options={typeOptions}
                                        placeholder="Select Category Type"
                                        menuPlacement="top"
                                        isClearable
                                        components={{ ClearIndicator }}
                                        styles={{
                                            container: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                            }),
                                            control: (provided) => ({
                                                ...provided,
                                                minHeight: '32px',
                                                fontSize: '13px',
                                                color: '#525A66',
                                                borderRadius: '4px',
                                                borderColor: '#d1d5db', // optional: match input border color
                                                boxShadow: 'none',
                                            }),
                                            placeholder: (provided) => ({
                                                ...provided,
                                                fontSize: '13px',
                                                color: '#999',
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 9999,
                                            }),
                                            option: (base, { isFocused }) => ({
                                                ...base,
                                                backgroundColor: isFocused ? '#f2f2f2' : '#fff',
                                                color: '#333',
                                                padding: '10px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #eee',
                                                '&:active': {
                                                    backgroundColor: '#f2f2f2',
                                                }
                                            }),
                                        }}
                                    />

                                    {errors.category_id && (
                                        <div className="error-message" style={{ color: 'red', fontSize: '12px' }}>
                                            {errors.category_id}
                                        </div>
                                    )}
                                </div>


                                <div className="charge-code-popup-form-group" style={{ flex: 1 }}>
                                    <label htmlFor="uom" className="charge-code-popup-label">UOM</label>
                                    <Select
                                        id="uom"
                                        value={uomOptions.find(opt => opt.value === uom) || null}
                                        onChange={(selectedOption) => setUom(selectedOption ? selectedOption.value : '')}
                                        options={uomOptions}
                                        placeholder="Select UOM"
                                        isClearable
                                        styles={{
                                            container: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                            }),
                                            control: (provided) => ({
                                                ...provided,
                                                minHeight: '32px',
                                                fontSize: '13px',
                                                color: '#525A66',
                                                borderRadius: '4px',
                                                borderColor: '#d1d5db', // optional: match input border color
                                                boxShadow: 'none',
                                            }),
                                            placeholder: (provided) => ({
                                                ...provided,
                                                fontSize: '13px',
                                                color: '#999',
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 9999,
                                            }),
                                        }}
                                        menuPlacement="auto"
                                    />
                                </div>
                            </div>

                        </div>

                        <div style={{ padding: "0px 20px 15px 20px" }} className="charge-code-creation-popup-footer">
                            <button type="button" className="charge-code-popup-clear-btn" onClick={handleClear}>Clear</button>
                            <button type="submit" className="charge-code-popup-submit-btn">
                                {editData ? 'Update' : 'Submit'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </>
    );
};

export default ChargeCodePopup;